export default __webpack_public_path__ + "static/8015-lense-box2-b5f83437119ad2db69ce82b420262b21.webp";